import { TooltipIfTruncatedModule } from './../../../directives';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { OverlayModule } from '@angular/cdk/overlay';

import { MultiSelectorFormFieldComponent } from './multi-selector-form-field.component';
import { MatChipsModule } from '@angular/material/chips';
import { GetBindLabelPipe } from './pipes';
import { MultiSelectorOptionStatePipe } from './pipes/multi-selector-option-state.pipe';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OptionTemplateDirective } from './directives/option-template.directive';
import { MatPseudoCheckboxModule } from '@angular/material/core';
import { SelectAllCheckboxStatePipe } from '../../../pipes';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
    declarations: [MultiSelectorFormFieldComponent, GetBindLabelPipe, OptionTemplateDirective],
	imports: [
		CommonModule,
		MatFormFieldModule,
		MatInputModule,
		ReactiveFormsModule,
		MatProgressSpinnerModule,
		MatChipsModule,
		OverlayModule,
		TooltipIfTruncatedModule,
		MatTooltipModule,
		MatPseudoCheckboxModule,
		SelectAllCheckboxStatePipe,
		MultiSelectorOptionStatePipe,
		FontAwesomeModule,
	],
    exports: [MultiSelectorFormFieldComponent, OptionTemplateDirective]
})
export class MultiSelectorFormFieldModule {}
